import { Plan, Voucher } from '@smarty-nx/data'

export const filterPlansById = (plans: Plan[], planId: string) =>
  plans.filter((plan) => planId !== plan?.id)

export const filterPlansByIdAndVoucher = (
  plans: Plan[],
  planId: string,
  voucher: Voucher | null
) =>
  plans.filter(
    (plan) =>
      planId !== plan?.id ||
      (plan?.voucher !== null && voucher === null) ||
      (plan?.voucher && plan?.voucher?.code !== voucher?.code)
  )
